import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const Timer = ({
  startTime, endTime, dead, fullText,
}) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const endDate = new Date(endTime);
    const difference = endDate - now;

    if (difference <= 0) {
      // Timer has ended
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const timeElapsed = () => {
    const sTime = new Date(startTime);
    const eTime = new Date(endTime);

    // Calculate time difference in milliseconds
    const timeDifference = eTime - sTime;

    // Convert milliseconds to seconds
    const seconds = Math.floor(timeDifference / 1000);

    // Calculate minutes and remaining seconds
    const minutes = Math.floor(seconds / 60);
    const eSeconds = seconds % 60;

    // Calculate hours and remaining minutes
    const hours = Math.floor(minutes / 60);

    const eMinutes = minutes % 60;

    // Calculate days and remaining hours
    const eDays = Math.floor(hours / 24);
    const eHours = hours % 24;

    return {
      eDays,
      eHours,
      eMinutes,
      eSeconds,
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [startTime, endTime]);

  return (
    <Fragment>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '13px',
        fontWeight: '500',
      }}
      >
        {dead ? (
          <Fragment>
            {
              timeElapsed().eDays > 0 ? `${timeElapsed().eDays?.toString().padStart(2, '0')} Days  
   ${timeElapsed().eHours?.toString().padStart(2, '0')} Hours` : ''
            }
            {
              !timeElapsed().eDays && timeElapsed().eHours > 0 ? `${timeElapsed().eHours?.toString().padStart(2, '0')} Hours  
   ${timeElapsed().eMinutes?.toString().padStart(2, '0')} Minutes` : ''
            }
            {
              !timeElapsed().eDays && !timeElapsed().eHours ? `${timeElapsed().eMinutes?.toString().padStart(2, '0')} Minutes  
   ${timeElapsed().eSeconds?.toString().padStart(2, '0')} Seconds` : ''
            }
          </Fragment>
        ) : (
          <Fragment>
            {
              timeLeft.days > 0 ? `${fullText ? 'Ending in ' : '' }${timeLeft.days?.toString().padStart(2, '0')} Days  
    ${timeLeft.hours?.toString().padStart(2, '0')} Hours` : ''
            }
            {
              !timeLeft.days && timeLeft.hours > 0 ? `${fullText ? 'Ending in ' : '' }${timeLeft.hours?.toString().padStart(2, '0')} Hours  
    ${timeLeft.minutes?.toString().padStart(2, '0')} Minutes` : ''
            }
            {
              !timeLeft.days && !timeLeft.hours ? `${fullText ? 'Ending in ' : '' } ${timeLeft.minutes?.toString().padStart(2, '0')} Minutes  
    ${timeLeft.seconds?.toString().padStart(2, '0')} Seconds` : ''
            }
          </Fragment>
        ) }

      </div>
    </Fragment>
  );
};

Timer.propTypes = {
  startTime: PropTypes.any,
  endTime: PropTypes.any,
};

export default Timer;
